/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmOAuthProfil extends GContentBase<SeznamAdmOAuthProfilObj> {
        private seznamObj: SeznamAdmOAuthProfilObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmOAuthProfilObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmOAuthProfil",
                contentCaption: "jres:33000385", //RC 33000385 : OAuth profily
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_oap}"
                },
                gridSettings: {
                    columnOrder: "nazev,poznamka,ixs_oap,dat_zmena,zmenu_prov_txt,tenant_id,typ_cloudu_txt,clie_id,o365_url,typ_aut_oauth_txt"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmOAuthProfilObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmOAuthProfil", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmOAuthProfil",
                newRecord: isNew,
                ixs_oap: isNew == true ? null : data.ixs_oap
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return {
                actOAuthProfileDialog: {
                    caption: "jres:33000390", //RC 33001052 : Z�skat adm. souhlas
                    tooltip: "jres:33001053", //RC 33001053 : Z�sk� administr�torsk� souhlas pro tento OAuth profil
                    icon: "fa-external-link",
                    run: (ev, ctx) => {
                        this.actOAuthProfileDialog()
                    }
                }
            }
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOAuthProfileDialog*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "-", "actOAuthProfileDialog*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmOAuthProfil.list({ filters: filterData }).getView().done((data) => {
                this.setPlatnostColumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            var sel = objArr.getSelection();
            if (sel.length == 1) 
                this.cnt.actions.actOAuthProfileDialog?.update({ enabled: sel[0].typ_aut_oauth == 10 && sel[0].aktivita == 100 })
            else 
                this.cnt.actions.actOAuthProfileDialog?.update({ enabled: false })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.ixs_oap),
                nazev: `${data.nazev}`
            }
        }

        private actOAuthProfileDialog() {
            var activeRow = this.cnt.grid.ggrid("activeRow");
            if (activeRow != null && activeRow != undefined) {
                this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.OAuthProfileDialog"], {
                    ixs_oap: activeRow.ixs_oap,
                    type: activeRow.typ_aut_oauth == 10 ? TypeDialogs.consent : TypeDialogs.login
                }, {
                    width: 400,
                    height: 300
                })
            }
        }
    }
}